var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconActiveBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 17,
  viewBox: "0 0 20 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_262_13268)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 7.5L19 7.5C19.55 7.5 20 7.95 20 8.5C20 9.05 19.55 9.5 19 9.5L1 9.5C0.450001 9.5 3.93403e-08 9.05 8.74228e-08 8.5C1.35505e-07 7.95 0.450001 7.5 1 7.5Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.00043 0.500175C8.26043 0.500175 8.51043 0.600176 8.71043 0.790175C9.10043 1.18018 9.10043 1.81017 8.71043 2.20018L2.42043 8.49017L8.71043 14.7902C9.10043 15.1802 9.10043 15.8102 8.71043 16.2002C8.32043 16.5902 7.69043 16.5902 7.30043 16.2002L0.30043 9.20018C-0.0895703 8.81018 -0.0895703 8.18017 0.30043 7.79017L7.30043 0.790175C7.50043 0.590175 7.75043 0.500175 8.01043 0.500175L8.00043 0.500175Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_262_13268"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 16,
  fill: "white",
  transform: "translate(20 16.5) rotate(-180)"
})))));
export default SvgIconActiveBack;